module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-secondary-bg.9c2f08e2.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-secondary-bg.png
// module id = 3606
// module chunks = 11